import React from 'react';
import { CollapseBlock, MainTitle, Spinner } from '../../../common/index.jsx';
import NewsArchiveTable from './NewsArchiveTable.jsx';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { useGetArchiveNewsQuery } from '../../../../redux/services/news.jsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BackIcon } from '../../../../utils/helpers/UtilityComponents.jsx';
const NewsArchivePage = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';
  const navigate = useNavigate();

  const { data: newsForArchive, isLoading: isLoadingNewsForArchive } =
    useGetArchiveNewsQuery(isEnglish);

  return isLoadingNewsForArchive ? (
    <Spinner />
  ) : (
    <>
      <CollapseBlock>
        <MainTitle title={t('Archív aktualít')} backAction={true} />
        <NewsArchiveTable
          news={newsForArchive}
          onDetailClick={(slug) =>
            navigate(`${isEnglish ? routes.newsDetailEnglish : routes.newsDetail}/${slug}`)
          }
          isEnglish={isEnglish}
        />
      </CollapseBlock>
    </>
  );
};

export default NewsArchivePage;
